import { useTheme } from "@/theme/ThemeProvider";
import {
  announceNoticeIfNeeded,
  noticeSpokenText,
  type ActionNoticeTone,
} from "@/ui/actionNotice";
import { useEffect } from "react";
import { AccessibilityInfo, Platform, Text, View } from "react-native";

export function ActionNotice({
  notice,
}: {
  notice: { tone: ActionNoticeTone; text: string } | null;
}) {
  const { theme } = useTheme();
  const spoken = notice ? noticeSpokenText(notice.tone, notice.text) : null;
  const tone = notice?.tone ?? "info";
  const border =
    tone === "success"
      ? theme.color.success
      : tone === "error"
        ? theme.color.danger
        : theme.color.info;
  const background =
    tone === "success"
      ? theme.color.successBg
      : tone === "error"
        ? theme.color.dangerBg
        : theme.color.infoBg;

  useEffect(() => {
    announceNoticeIfNeeded(Platform.OS, spoken, (message) => {
      AccessibilityInfo.announceForAccessibility(message);
    });
  }, [spoken]);

  const shown = Boolean(notice && spoken);

  return (
    <View
      accessibilityLiveRegion={notice?.tone === "error" ? "assertive" : "polite"}
      style={
        shown
          ? {
              marginTop: theme.space.sm,
              padding: theme.space.md,
              borderRadius: theme.radius.md,
              backgroundColor: background,
              borderWidth: 1,
              borderColor: border,
            }
          : { position: "absolute", height: 0, width: 0, overflow: "hidden" }
      }
    >
      {shown ? (
        <Text style={{ color: theme.color.text, fontSize: theme.fontSize.small }}>{spoken}</Text>
      ) : null}
    </View>
  );
}
